import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const TooltipPositionerContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") TooltipPositionerContext.displayName = "TooltipPositionerContext";
function useTooltipPositionerContext() {
  const context = React.useContext(TooltipPositionerContext);
  if (context === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : formatErrorMessage(71));
  }
  return context;
}
export {
  TooltipPositionerContext,
  useTooltipPositionerContext
};
//# sourceMappingURL=TooltipPositionerContext.js.map
